class Confirm {
    click(el) {

        if(typeof el.callback == "undefined"){
            el.callback = el.getAttribute("data-confirm-callback");
            el.positive = el.getAttribute("data-confirm-positive");
            el.negative = el.getAttribute("data-confirm-negative");
            el.header = el.getAttribute("data-confirm-header");
        }

        app.confirm._callback = el.callback;

        app.alert.prompt(el.header, "<div class='d-sm-flex flex-sm-row-reverse justify-content-around'><div onclick=\"app.confirm.callback(this);app.alert.close();\" class='positive btn btn-green choice btn-block-xs-only'>" + el.positive + "</div><div class='negative btn choice btn-block-xs-only btn-red' onclick='app.alert.close()'>" + el.negative + "</div></div>");
    }

    callback(elem) {
        if (typeof app.confirm._callback === 'string') {
            eval(app.confirm._callback);
        }
        else {
            app.confirm._callback(elem);
        }
    }
}
